export const strEllipsis = (str: any, n: any) => {
    return str ? (str.length > n ? str.substr(0, n - 1) + '...' : str) : '';
};
